import { CalendarDate, Maybe } from "@sp-crm/core";

export interface PipelineStatusDateSource {
    pipelineDateField?: string | null;
    pipelineDateLabel?: string | null;
}

export interface PipelineStatusDate {
    descriptor: string;
    date: Maybe<CalendarDate>;
}

export const pipelineStatusDate = (
    status: PipelineStatusDateSource | null,
    item: object,
): PipelineStatusDate => {
    if (!status?.pipelineDateField) {
        return { descriptor: "", date: Maybe.none<CalendarDate>() };
    }
    const value: unknown = Reflect.get(item, status.pipelineDateField);
    return {
        descriptor: status.pipelineDateLabel || "",
        date: Maybe.fromValue(typeof value === "string" ? value : null).flatMap(v =>
            CalendarDate.parse(v),
        ),
    };
};
